module.exports = __webpack_public_path__ + "static/imagem_8-2cae41672b1870c16f9cf15ff8e935b3.jpeg";